import React, {useState} from "react";
import {IMenuItem} from "modules/types";
import styled from "styled-components";
import {NavLink} from "react-router-dom";
import {useSelector} from "react-redux";
import {isAuthedSelector} from "modules/selectors";
import chevronIcon from "assets/img/icons/chevron.svg";
import theme from "assets/css/theme";
import {partial, get} from "lodash";
import externalIcon from "assets/img/icons/external.png";

const Wrapper = styled.div<{
	isHideItem: boolean;
	isSub?: boolean;
}>`
	background: ${(props) => (props.isSub ? "#12156F" : "#1d22a9")};
	height: ${(props) => (props.isSub ? "50px" : "61px")};
	width: 100%;
	color: #ffffff;
	font-size: 14px;
	font-family: ${(props) => (props.isSub ? theme.base_font : theme.mediumFont)};
	border-bottom: 1px solid;
	border-color: ${(props) => (props.isSub ? "rgba(255,255,255, 0.1)" : "#12156F")};
	display: ${(props) => (props.isHideItem ? "none" : "flex")};
`;
const NavItem = styled(NavLink)`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		margin-left: 10px;
	}
`;
export const DropdownItem = styled.div<{isOpen?: boolean}>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		filter: invert(1);
		transform: rotate(${(props) => (props.isOpen ? "0deg" : "180deg")});
		margin-left: 10px;
	}
`;
interface IProps {
	item: IMenuItem;
	isSub?: boolean;
}

export const MobileItem: React.FC<IProps> = ({item, isSub}) => {
	const isAuthed = useSelector(isAuthedSelector);
	const [isOpen, setIsOpen] = useState(false);
	const isHideItem = (targetItem: IMenuItem) => !isAuthed && targetItem.isAuthed;
	const mobileLink = get(item, "mobileLink", item.link);
	return (
		<React.Fragment>
			<Wrapper isHideItem={isHideItem(item)} isSub={isSub}>
				{!item.isExternal && !item.subItems ? (
					<NavItem to={mobileLink}>{window.getTranslations(item.label)}</NavItem>
				) : null}
				{item.isExternal ? (
					<NavItem as={"a"} href={item.link} target={"_blank"} rel="noopener noreferrer">
						{window.getTranslations(item.label)}
						<img src={externalIcon} alt={"External Icon"} />
					</NavItem>
				) : null}
				{item.subItems ? (
					<React.Fragment>
						<DropdownItem isOpen={isOpen} onClick={partial(setIsOpen, !isOpen)}>
							{window.getTranslations(item.label)}
							<img src={chevronIcon} alt="Chevron Icon" />
						</DropdownItem>
					</React.Fragment>
				) : null}
			</Wrapper>
			{item.subItems &&
				isOpen &&
				item.subItems.map((subItem) => <MobileItem item={subItem} key={subItem.label} isSub={true} />)}
		</React.Fragment>
	);
};
